module.exports = __webpack_public_path__ + "static/media/panel.workfile.713234db.png";